import { render, staticRenderFns } from "./TheProductCustomizerMain.vue?vue&type=template&id=21eb148e&"
import script from "./TheProductCustomizerMain.vue?vue&type=script&lang=js&"
export * from "./TheProductCustomizerMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21eb148e')) {
      api.createRecord('21eb148e', component.options)
    } else {
      api.reload('21eb148e', component.options)
    }
    module.hot.accept("./TheProductCustomizerMain.vue?vue&type=template&id=21eb148e&", function () {
      api.rerender('21eb148e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/customizer/TheProductCustomizerMain.vue"
export default component.exports